module.exports = __webpack_public_path__ + "img/tempix.d13d7527.webp";